import { ONBOARDING_PAGE_NS } from '../i18n';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import {
  EcosystemLogoUploader,
  FormHeader,
  FormTitle,
  IIconSelectorValue,
  ColorPicker,
  ThemeSwitcher,
  useOnboardingStore,
} from '@diana/core';

export const CustomiseEcosystem = () => {
  const { t } = useTranslation(ONBOARDING_PAGE_NS);
  const { palette } = useTheme();

  const file = useOnboardingStore((store) => store.logoFile);
  const setFile = useOnboardingStore((store) => store.setLogoFile);
  const color = useOnboardingStore((store) => store.color) ?? palette.primary.main;
  const setColor = useOnboardingStore((store) => store.setColor);
  const ecosystemName = useOnboardingStore((store) => store.ecosystemName) ?? '';

  const onChangeColor = ({ color }: IIconSelectorValue) => {
    setColor(color);
  };

  return (
    <Stack gap={4}>
      <Stack gap={0.5}>
        <Typography variant="h2">{t('steps.ecosystem.component.title')}</Typography>
        <Typography color={palette.text.secondary}>
          {t('steps.ecosystem.component.description')}
        </Typography>
      </Stack>
      <Stack gap={3}>
        <EcosystemLogoUploader
          file={file}
          setFile={setFile}
          color={color}
          ecosystemName={ecosystemName}
          isDefaultEcosystem
        />
        <Box>
          <FormHeader>
            <FormTitle title={t('steps.ecosystem.component.color')} />
          </FormHeader>
          <ColorPicker onChange={onChangeColor} color={color} />
        </Box>
        <Stack gap={0.5}>
          <Typography color={palette.text.secondary}>
            {t('steps.ecosystem.component.theme')}
          </Typography>
          <Box my={1}>
            <ThemeSwitcher />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};
